/* Tu Beauty 2027 · WhatsApp catalog handoff v1.0.0 · 2026-09-30.
   Reads current form values on click; no cart writes, prices, stock promises,
   customer data, automatic sends, network lookup or Pinecone dependency. */
(() => {
  'use strict';
  if (window.TBWhatsApp2027) return;
  window.TBWhatsApp2027 = { version: '1.0.0' };
  const phone = '12568407269';
  const clean = value => String(value == null ? '' : value).replace(/\s+/g, ' ').trim();
  const numericId = value => {
    if (typeof value === 'number' && !Number.isSafeInteger(value)) return '';
    const text = clean(value);
    return /^[1-9]\d*$/.test(text) ? text : '';
  };
  function readJson(element) {
    if (!element) return null;
    try { return JSON.parse(element.textContent); } catch (_) { return null; }
  }
  function visible(element) {
    if (!element || !element.isConnected || !element.getClientRects().length) return false;
    return !element.closest('[hidden],[aria-hidden="true"]') && getComputedStyle(element).visibility !== 'hidden';
  }
  function identity(form) {
    const data = readJson(form.querySelector('[data-tb-whatsapp-product]'));
    if (!data || !numericId(data.id) || !clean(data.title)) return null;
    const hiddenId = form.querySelector('[name="data-product-id"]');
    if (hiddenId && numericId(hiddenId.value) !== numericId(data.id)) return null;
    return data;
  }
  function pathHandle(pathname) {
    const match = pathname.match(/\/products\/([^/]+)\/?$/);
    if (!match) return '';
    try { return decodeURIComponent(match[1]); } catch (_) { return ''; }
  }
  function formContext() {
    // An open AJAX quick view must never inherit the product behind it.
    const layers = [...document.querySelectorAll('#ProductScreens .screen-layer--is-active,.screen-layer--is-active')].filter(visible);
    const activeLayer = layers[layers.length - 1];
    if (activeLayer) {
      const form = [...activeLayer.querySelectorAll('form.product-single__form')].find(visible);
      return form ? { form, product: identity(form) } : null;
    }
    const handle = pathHandle(window.location.pathname);
    if (!handle) return null;
    for (const form of document.querySelectorAll('#MainContent form.product-single__form')) {
      if (!visible(form) || form.closest('.screen-layer')) continue;
      const product = identity(form);
      if (product && clean(product.handle) === handle) return { form, product };
    }
    return null;
  }
  function selectedVariant(form, product) {
    const native = readJson(form.querySelector('[data-variant-json]'));
    const variants = Array.isArray(native) ? native.filter(v => v && numericId(v.id)) : [];
    const initial = product.initialVariant;
    if (initial && numericId(initial.id) && !variants.some(v => numericId(v.id) === numericId(initial.id))) variants.push(initial);
    const fields = [...form.querySelectorAll('select[data-variant-input],input[data-variant-input]')];
    if (fields.length && !product.hasOnlyDefaultVariant) {
      const count = Number(product.optionCount);
      if (!Number.isInteger(count) || count < 1 || count > 3) return null;
      const values = new Array(count);
      for (const field of fields) {
        if (field.type === 'radio' && !field.checked) continue;
        const index = Number(String(field.dataset.index || '').replace(/^option/, '')) - 1;
        if (Number.isInteger(index) && index >= 0 && index < count) values[index] = field.value;
      }
      for (let i = 0; i < count; i++) if (typeof values[i] !== 'string' || values[i] === '') return null;
      // Options win over a stale hidden variant ID while native scripts update.
      return variants.find(v => Array.isArray(v.options) && v.options.length === count && v.options.every((value, i) => value === values[i])) || null;
    }
    const selected = form.querySelector('select[name="id"],input[name="id"]');
    const id = selected ? numericId(selected.value) : '';
    return id ? variants.find(v => numericId(v.id) === id) || null : null;
  }
  function quantity(form) {
    const field = form.querySelector('[name="quantity"]');
    if (!field) return 1;
    const text = clean(field.value);
    const number = Number(text);
    return /^\d+$/.test(text) && Number.isSafeInteger(number) && number > 0 ? number : null;
  }
  function publicProductUrl(product, variant) {
    try {
      const url = new URL(product.url);
      if (url.protocol !== 'https:' || url.username || url.password || pathHandle(url.pathname) !== clean(product.handle)) return '';
      url.search = '';
      url.hash = '';
      if (variant) url.searchParams.set('variant', numericId(variant.id));
      return url.href;
    } catch (_) { return ''; }
  }
  function genericMessage() {
    // Never copy account paths, checkout tokens, tracking or preview parameters.
    return 'Hola 👋 ¿Me ayudas con una consulta en Tu Beauty Store?';
  }
  function message() {
    const context = formContext();
    if (!context || !context.product) return genericMessage();
    const { form, product } = context;
    const variant = selectedVariant(form, product);
    const qty = quantity(form);
    const lines = ['Hola 👋 ¿Me ayudas con este producto?', 'Producto: ' + clean(product.title)];
    const variantTitle = variant ? clean(variant.title) : '';
    if (!product.hasOnlyDefaultVariant) {
      lines.push('Variante: ' + (variant && variantTitle && !/^default title$/i.test(variantTitle) ? variantTitle : 'por confirmar'));
    }
    lines.push('Cantidad: ' + (qty === null ? 'por confirmar' : qty + (qty === 1 ? ' unidad' : ' unidades')));
    if (variant && clean(variant.sku)) lines.push('SKU: ' + clean(variant.sku));
    if (variant && clean(variant.barcode) && clean(variant.barcode) !== clean(variant.sku)) lines.push('Código de barras: ' + clean(variant.barcode));
    lines.push('ProductId: ' + numericId(product.id));
    if (variant) lines.push('VariantId: ' + numericId(variant.id));
    const url = publicProductUrl(product, variant);
    if (url) lines.push('Enlace: ' + url);
    return lines.join('\n');
  }
  function bind() {
    const button = document.getElementById('btnWhatsApp');
    if (!button || button.dataset.tbWhatsappBound) return;
    button.dataset.tbWhatsappBound = 'true';
    button.addEventListener('click', () => {
      let text;
      try { text = message(); } catch (_) { text = genericMessage(); }
      // Encode only the transport parameter; product names remain human text.
      const endpoint = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent) ? 'https://api.whatsapp.com/send' : 'https://web.whatsapp.com/send';
      window.open(endpoint + '?phone=' + phone + '&text=' + encodeURIComponent(text), '_blank', 'noopener,noreferrer');
    });
    // Cooperates with the existing premium script without duplicate key events.
    if (!button.dataset.tbAccessible) {
      button.dataset.tbAccessible = 'true';
      button.setAttribute('role', 'button');
      button.tabIndex = 0;
      button.setAttribute('aria-label', 'Consultar por WhatsApp');
      button.addEventListener('keydown', event => {
        if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); button.click(); }
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind, { once: true });
  else bind();
  document.addEventListener('shopify:section:load', bind);
})();
